import { useEffect, useMemo, useState } from "react";
import { Box, Stack, TextField, Button, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";


import BreadcrumbsBar from "../../../../component/common/BreadcrumbsBar";

import ReportContainer from "../../component/ReportContainer";
import ReportHeader from "../../component/ReportHeader";
import ReportToolbar from "../../component/ReportToolbar";
import ReportTitle from "../../component/ReportTitle";
import ReportActions from "../../component/ReportActions";
import ReportLoading from "../../component/ReportLoading";
import ReportNoData from "../../component/ReportNoData";
import { MenuItem } from "@mui/material";
import WGRViewer from "./ueViewer";
import { qtrCost } from "../../../../services/reportService";

import generateWGRPDF from "./pdfreport/uegeneratePDF";

import { useLocation } from "react-router-dom";

import SearchIcon from "@mui/icons-material/Search";

 const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  
];

export default function POHPage() {





  const location = useLocation();

  const report = location.state || {
    reportType: "IOH",
    title: "IOH Report(C/3)",
  };

  const { reportType, title } = report;

  const today = new Date();



  const month = location.state.month;
  const year = location.state.year;




  const [rows, setRows] = useState([]);

  const [loading, setLoading] = useState(false);

  const monthName = useMemo(
    () => months[month - 1],
    [month]
  );

  const loadReport = async () => {
    try {
      setLoading(true);

      const res = await qtrCost(month, year);

     // setRows(res.data.data || []);

 setRows(res?.data?.data || []);
      console.log(rows);

    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    loadReport();
  };

  const handlePrint = () => {
    window.print();

    setTimeout(() => {
      setRows([]);
    }, 500);
  };



  /*
     * Grand Total
     */
  




  const handlePdf = () => {
    generateWGRPDF(
      title,
       rows[0],
      "",
      monthName,
      year
    );
  };

  const handleExcel = () => {
    console.log("Generate Excel");
  };


  useEffect(() => {
    // Optional: Clear previous report
    setRows([]);

    // Load report if you want automatically
    loadReport();

  }, [reportType]);

  

  return (
    <Box >

      <BreadcrumbsBar page={title} />


    
      <ReportContainer>


        <ReportToolbar>

          <ReportTitle
            title={title} 
            subtitle={`from ${months[month*3 - 3]} ${year} to ${months[month*3 -1]} ${year} ` }
          />

          <Box className="no-print">
            <ReportActions
              onRefresh={handleRefresh}
              onPrint={handlePrint}
              onPdf={handlePdf}
              onExcel={handleExcel}
            />
          </Box>



        </ReportToolbar>

        {loading ? (
          <ReportLoading />
        ) : (
          <WGRViewer
            rows={rows[0]}
            
            
          />
        )}

      </ReportContainer>

    </Box>
  );
}